module.exports = """
  fragment followed_artist_context on HomePageModuleContextFollowedArtist {
    artist {
      href
      id
    }
  }
"""
